import {
  createActivityForMaterialItem,
  getUnitLessonIdParts,
} from './gDriveUtils'
import { createNodeList } from '../nodeCreationHelpers'
import { IUnitLessonParams, ParsedGoogleDocType } from './types'

export function parseLessonItems(params: IUnitLessonParams) {
  const items = getLessonActivityItems(params)
  if (!items.length) return []

  const childNodes = items.map((item) => {
    return createActivityForMaterialItem(item)
  })

  return [createNodeList({ title: 'Activities' }, childNodes)]
}

type ActivityItemType = 'HO' | 'RDG' | 'REF'

function getLessonActivityItems(params: IUnitLessonParams) {
  const { unitCode, lessonCode } = getUnitLessonIdParts(params)
  const itemTypes: ActivityItemType[] = ['HO', 'RDG', 'REF']
  const prefix = unitCode + lessonCode
  const grouped = Object.entries(params.gDrive).reduce<
    Record<ActivityItemType, { content: ParsedGoogleDocType; name: string }[]>
  >(
    (acc, [key, content]) => {
      const group = itemTypes.find((t) => {
        return key.includes(prefix + t)
      })
      if (!group) return acc
      return {
        ...acc,
        [group]: [...acc[group], { content, name: key }],
      }
    },
    { HO: [], RDG: [], REF: [] },
  )

  const getGroupSort = (groupCode: string) => {
    return (g1: { name: string }, g2: { name: string }) => {
      const num1 = parseInt(g1.name.replace(prefix + groupCode, ''), 10) ?? 0
      const num2 = parseInt(g2.name.replace(prefix + groupCode, ''), 10) ?? 0
      return num1 - num2
    }
  }

  return itemTypes.reduce<ParsedGoogleDocType[]>((acc, type) => {
    const sorted = grouped[type]
      .sort(getGroupSort(type))
      .map(({ content }) => content)
    return [...acc, ...sorted]
  }, [])
}
